import axios from 'axios';
import * as config from './constants/configuration';
import {canReport} from './constants/utils';

export function getData(url, thenHandler, errorHandler, user, absoluteURL = false) {
    let token = user ? user.access_token : "";

    const callURL = absoluteURL ? url : config.API_URI() + url;

    return axios.get(callURL,
        {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    ).then((response) => {
        thenHandler(response);
    }).catch((error) => {
        errorHandler(error);
    });
}

export function postData(url, thenHandler, errorHandler, data, user, absoluteURL = false) {
    let token = user ? user.access_token : "";
    
    const callURL = absoluteURL ? url : config.API_URI() + url;

    return axios.post(callURL, data,
        {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    ).then((response) => {
        thenHandler(response);
    }).catch((error) => {
        errorHandler(error);
    });
}

export function putData(url, thenHandler, errorHandler, data, user, absoluteURL = false) {
    let token = user ? user.access_token : "";

    const callURL = absoluteURL ? url : config.API_URI() + url;

    return axios.put(callURL, data,
        {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    ).then((response) => {
        thenHandler(response);
    }).catch((error) => {
        errorHandler(error);
    });
}

export function deleteData(url, thenHandler, errorHandler, user, absoluteURL = false) {
    let token = user ? user.access_token : "";

    const callURL = absoluteURL ? url : config.API_URI() + url;

    return axios.delete(callURL,
        {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    ).then((response) => {
        thenHandler(response);
    }).catch((error) => {
        errorHandler(error);
    });
}

export function createReport(data, format, user, suffix, props = {}) {
    const url = suffix ? config.REPORTS_API_URI() + suffix : config.REPORTS_API_URI();
    let token = user ? user.access_token : "";
    axios.post(config.API_URI() + 'Trazas', { 
        usuario: user.profile.name,
        reporte: data.reportDefinition.reportFile,
        centro: data.values.centroId,
        fechaInicial: data.values.iniDate,
        fechaFinal: data.values.endDate
        }, {headers: {
                    Authorization: "Bearer " + token
                },});
    // if((canReport(data.values.iniDate, props)))   {
        return axios.post(url + '?type=' + format, data,
            {
                headers: {
                    Authorization: "Bearer " + token
                },
                responseType: 'blob'
            }
        );
    // }
    // else{
    //     return Promise.reject({
    //         response: {
    //         status: 401,
    //         data: "No esta autorizado para generar este reporte"
    //         }
    //     });
    // }

}


export function getTextFile(url, thenHandler, errorHandler, endHandler, filename, user) {
  
    let token = user ? user.access_token : "";
    return axios.get(config.API_URI() + url,
        {
            headers: {
                Authorization: "Bearer " + token
            },
            responseType: 'blob'
        }
    ).then((response) => {
        if (thenHandler === undefined) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        }
        else{
            thenHandler(response);
        }
        endHandler();

    }).catch((error) => {
        errorHandler(error);
        endHandler();
    });

}

export function CHANGEVERSIONBUILD(user) {
    let pjson = require("../package.json");
    getData('Global/3', response => {
      if (pjson.version !== response.data) {
        window.location.reload(true);
      }
    }, undefined, user);
  }
